var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.945 14.585H6.315c-2.812 0-5.1-2.29-5.1-5.106s2.288-5.107 5.1-5.107h.363v-.286c0-2.25 1.828-4.08 4.075-4.08 2.206 0 4.009 1.765 4.073 3.959.324-.1.664-.152 1.011-.152 1.773 0 3.234 1.36 3.398 3.092 1.982.15 3.55 1.812 3.55 3.835 0 2.12-1.723 3.845-3.84 3.845zM11.302 16.588v1.835c.229-.047.466-.072.708-.072.239 0 .471.024.696.07v-1.833c0-.388-.314-.702-.702-.702-.388 0-.702.314-.702.702zM17.557 21.151h-1.835c.047.23.072.466.072.709 0 .238-.024.47-.07.696h1.833c.387 0 .702-.315.702-.702 0-.388-.315-.703-.702-.703zM6.553 21.151h1.835c-.048.23-.073.466-.073.709 0 .238.025.47.07.696H6.553c-.388 0-.702-.315-.702-.702 0-.388.314-.703.702-.703z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M2.14 23.995c1.18 0 2.138-.959 2.138-2.142 0-1.183-.957-2.142-2.139-2.142C.958 19.71 0 20.67 0 21.853c0 1.183.958 2.142 2.14 2.142z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M12.01 23.995c1.182 0 2.14-.959 2.14-2.142 0-1.183-.958-2.142-2.14-2.142-1.181 0-2.139.959-2.139 2.142 0 1.183.958 2.142 2.14 2.142z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M21.86 23.995c1.182 0 2.14-.959 2.14-2.142 0-1.183-.958-2.142-2.14-2.142-1.18 0-2.138.959-2.138 2.142 0 1.183.957 2.142 2.139 2.142z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.731,
    x2: -1.198,
    y1: 23.817,
    y2: 19.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.602,
    x2: 8.673,
    y1: 23.817,
    y2: 19.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.453,
    x2: 18.524,
    y1: 23.817,
    y2: 19.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeHosting);
export default __webpack_public_path__ + "static/media/free-hosting.c7a45c9559f471ff41e48740f4ab8c02.svg";
export { ForwardRef as ReactComponent };